var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.opened
    ? _c("div", { staticClass: "modal-mask" }, [
        _c("div", { staticClass: "modal-wrapper" }, [
          _c(
            "div",
            { staticClass: "modal-dialog modal-xl modal-dialog-scrollable" },
            [
              _vm.step === "start"
                ? _c("div", { staticClass: "modal-content" }, [
                    _c("div", { staticClass: "modal-header" }, [
                      _c("h5", { staticClass: "modal-title" }, [
                        _vm._v("Save to attribute"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "close",
                          attrs: { type: "button" },
                          on: { click: _vm.close },
                        },
                        [_vm._v("×")]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "modal-body" }, [
                      _c("div", { staticClass: "card-deck" }, [
                        _c(
                          "div",
                          {
                            staticClass: "card",
                            class: {
                              "border-primary":
                                _vm.useExistingAttribute === false,
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "card-header pointer",
                                class: {
                                  "text-white bg-primary":
                                    _vm.useExistingAttribute === false,
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.useExistingAttribute = false
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "fa-regular",
                                  class: {
                                    "fa-square":
                                      _vm.useExistingAttribute === true,
                                    "fa-square-check":
                                      _vm.useExistingAttribute === false,
                                  },
                                  attrs: { "aria-hidden": "true" },
                                }),
                                _vm._v(
                                  "\n                                Create new attribute \n                            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "card-body" }, [
                              _c("div", { staticClass: "form-group" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model.trim",
                                      value: _vm.newAttributeName,
                                      expression: "newAttributeName",
                                      modifiers: { trim: true },
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: { type: "text" },
                                  domProps: { value: _vm.newAttributeName },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.newAttributeName =
                                        $event.target.value.trim()
                                    },
                                    blur: function ($event) {
                                      return _vm.$forceUpdate()
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _vm.duplicatedName === true
                                  ? _c(
                                      "small",
                                      { staticClass: "text-danger" },
                                      [
                                        _vm._v(
                                          "Sorry, this name is already being used. Please change the name to a unique name."
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "small",
                                  { staticClass: "form-text text-muted" },
                                  [
                                    _vm._v(
                                      'Values will be saved as a new attribute in "Value scores" section.'
                                    ),
                                  ]
                                ),
                              ]),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "card",
                            class: {
                              "border-primary":
                                _vm.useExistingAttribute === true,
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "card-header pointer",
                                class: {
                                  "text-white bg-primary":
                                    _vm.useExistingAttribute === true,
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.useExistingAttribute = true
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "fa-regular",
                                  class: {
                                    "fa-square":
                                      _vm.useExistingAttribute === false,
                                    "fa-square-check":
                                      _vm.useExistingAttribute === true,
                                  },
                                  attrs: { "aria-hidden": "true" },
                                }),
                                _vm._v(
                                  "\n                                Use existing attribute\n                            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "card-body" }, [
                              _c("div", { staticClass: "form-group" }, [
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.existingAttribute,
                                        expression: "existingAttribute",
                                      },
                                    ],
                                    staticClass: "form-control",
                                    on: {
                                      change: function ($event) {
                                        var $$selectedVal =
                                          Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function (o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function (o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                        _vm.existingAttribute = $event.target
                                          .multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "option",
                                      { domProps: { value: null } },
                                      [_vm._v("Choose...")]
                                    ),
                                    _vm._v(" "),
                                    _vm._l(_vm.attributes, function (attr) {
                                      return _c(
                                        "option",
                                        { domProps: { value: attr } },
                                        [_vm._v(_vm._s(attr.Name))]
                                      )
                                    }),
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _c(
                                  "small",
                                  { staticClass: "form-text text-muted" },
                                  [
                                    _vm._v(
                                      "\n                                        Values will be saved to the existing attribute.\n                                    "
                                    ),
                                  ]
                                ),
                              ]),
                            ]),
                          ]
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "modal-footer" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-primary",
                          attrs: { type: "button" },
                          on: { click: _vm.showPreview },
                        },
                        [_vm._v("Preview")]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-outline-secondary",
                          attrs: { type: "button" },
                          on: { click: _vm.close },
                        },
                        [_vm._v("Cancel")]
                      ),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.step === "preview"
                ? _c("div", { staticClass: "modal-content" }, [
                    _c("div", { staticClass: "modal-header" }, [
                      _c("h5", { staticClass: "modal-title" }, [
                        _vm._v("Preview"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "close",
                          attrs: { type: "button" },
                          on: { click: _vm.close },
                        },
                        [_vm._v("×")]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "modal-body" }, [
                      _c(
                        "table",
                        { staticClass: "table table-bordered table-hover" },
                        [
                          _c("thead", [
                            _c("tr", [
                              _c("th", [_vm._v(_vm._s(_vm.attributeName))]),
                              _vm._v(" "),
                              _c("th", [_vm._v("Value")]),
                            ]),
                          ]),
                          _vm._v(" "),
                          _vm.changes
                            ? _c(
                                "tbody",
                                _vm._l(_vm.changes, function (a) {
                                  return _c("tr", { key: a.Id }, [
                                    _c("td", [_vm._v(_vm._s(a.Name))]),
                                    _vm._v(" "),
                                    _c("td", { staticClass: "text-center" }, [
                                      _c("span", [_vm._v(_vm._s(a.NewValue))]),
                                      _vm._v(" "),
                                      a.OldValue != null
                                        ? _c("small", [
                                            _c("br"),
                                            _vm._v(
                                              "\n                                        (Current: "
                                            ),
                                            _c(
                                              "span",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(a.OldValue))]
                                            ),
                                            _vm._v(
                                              ")\n                                    "
                                            ),
                                          ])
                                        : _vm._e(),
                                    ]),
                                  ])
                                }),
                                0
                              )
                            : _vm._e(),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "modal-footer d-flex justify-content-between",
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-outline-secondary",
                            attrs: { type: "button" },
                            on: { click: _vm.showStart },
                          },
                          [_vm._v("Back")]
                        ),
                        _vm._v(" "),
                        _c("div", [
                          _vm.saving === true
                            ? _c(
                                "button",
                                {
                                  staticClass: "btn btn-primary",
                                  attrs: { type: "button" },
                                  on: { click: _vm.saveChanges },
                                },
                                [
                                  _c("i", {
                                    staticClass: "fa fa-spinner fa-spin",
                                  }),
                                  _vm._v(
                                    " Saving...\n                        "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.saving === false
                            ? _c(
                                "button",
                                {
                                  staticClass: "btn btn-primary",
                                  attrs: { type: "button" },
                                  on: { click: _vm.saveChanges },
                                },
                                [_vm._v("Save")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-outline-secondary",
                              attrs: { type: "button" },
                              on: { click: _vm.close },
                            },
                            [_vm._v("Cancel")]
                          ),
                        ]),
                      ]
                    ),
                  ])
                : _vm._e(),
            ]
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }